import { DateTime } from 'luxon';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';
import { ISTAT_MILANO } from 'shell/constants/istat-milano';
import { UserProfile } from 'shell/hooks/use-user-profile/types';
import { SubjectData } from 'shell/models/person';
import { AccordionPersonForm as PersonVM } from 'shell/view-models/accordion-person-form';

export const transformPerson = (
  person: SubjectData,
  userProfile?: UserProfile
): PersonVM | null => {
  const residenceArray = person?.residenza || [];

  const enrollData = person?.datiIscrizione;

  let state = '';

  let resident = false;

  // state check for object
  if (residenceArray[0]?.indirizzo?.toponimo) {
    if (residenceArray[0]?.indirizzo?.comune?.codiceIstat === userProfile?.datiLogin?.codiceIstat) {
      state = 'Residente';
      resident = true;
    } else {
      state = `Residente a ${residenceArray[0]?.indirizzo?.comune?.nomeComune || ''}`;
      resident = false;
    }
  }

  if (person?.generalita?.soggettoAIRE && person?.generalita?.soggettoAIRE === 'S') {
    if (
      (residenceArray[0]?.localitaEstera?.indirizzoEstero ||
        residenceArray[0]?.localitaEstera?.consolato) &&
      enrollData?.datiIscrizioneComune?.comune?.codiceIstat !== ISTAT_MILANO
    ) {
      state = `Iscritto AIRE - ${enrollData?.datiIscrizioneComune?.comune?.nomeComune || ''}`;
      resident = false;
    } else {
      state = 'Iscritto AIRE';
      resident = true;
    }
  }

  if (person?.datiCancellazione && person?.datiCancellazione?.descrizioneMotivoCancellazione) {
    state = `Cancellato per: ${person.datiCancellazione.descrizioneMotivoCancellazione}`;
  }

  if (person?.descrizioneStatusPersonaSipo) {
    state = person.descrizioneStatusPersonaSipo;
  }

  const birthChoiceDate = transformToChoiceDate(
    person?.generalita?.senzaGiorno || '',
    person?.generalita?.senzaGiornoMese || ''
  );

  const originReturnData: PersonVM | null = person?.generalita
    ? {
        fiscalCode: person.generalita?.codiceFiscale?.codFiscale || '',
        validityFiscalCodeId: person.generalita?.codiceFiscale?.validitaCF || '',
        resident,
        name: person.generalita?.nome || '',
        surname: person.generalita?.cognome || '',
        withoutName: person.generalita?.senzaNome === '1' ? true : false,
        withoutSurname: person.generalita?.senzaCognome === '1' ? true : false,
        birthChoiceDate,
        birthDate: person.generalita?.dataNascita
          ? DateTime.fromISO(person.generalita?.dataNascita)
          : null,
        gender: person.generalita?.sesso || '',
        idFamigliaConvivenza:
          person.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenza || '',
        codeIstat:
          person.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenzaComuneIstat ||
          '',
        subjectAire: person.generalita?.soggettoAIRE || '',
        codeLink: person.legameSoggetto?.codiceLegame || '',
        residence: person?.residenza || undefined,
        citizenship: person?.cittadinanza || undefined,
        famigliaConvivenza: person?.famigliaConvivenza || undefined,
        idSchedaSoggetto: person?.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto,
        idSchedaSoggettoComuneIstat:
          person?.generalita?.idSchedaSoggettoComune?.idSchedaSoggettoComuneIstat,
        generality: person?.generalita,
        idSchedaSoggettoANPR: person.generalita.idSchedaSoggettoANPR,
        state,
        // valori per nascita
        isForeign: person.generalita?.luogoNascita?.localita ? true : false,
        exceptionalBirthPlace: person.generalita?.luogoNascita?.luogoEccezionale || '',
        // generality italian form
        italian: person.generalita?.luogoNascita?.comune
          ? {
              location: person.generalita?.luogoNascita?.comune?.descrizioneLocalita || '',
              province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
              municipality: person.generalita?.luogoNascita?.comune?.nomeComune
                ? {
                    id: person.generalita?.luogoNascita?.comune?.codiceIstat || '',
                    description: person.generalita?.luogoNascita?.comune?.nomeComune || '',
                    province: person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
                  }
                : null,
              municipalityIsValid: person.generalita?.luogoNascita?.comune?.codiceIstat
                ? true
                : false,
            }
          : undefined,
        // generality foreign form
        foreign: person.generalita?.luogoNascita?.localita
          ? {
              state: person.generalita?.luogoNascita?.localita?.codiceStato
                ? {
                    id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                    value: person.generalita?.luogoNascita?.localita?.descrizioneStato || '',
                    province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
                  }
                : null,
              province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
              municipality: person.generalita?.luogoNascita?.localita?.codiceStato
                ? {
                    id: person.generalita?.luogoNascita?.localita?.codiceStato || '',
                    description:
                      person.generalita?.luogoNascita?.localita?.descrizioneLocalita || '',
                    province: person.generalita?.luogoNascita?.localita?.provinciaContea || '',
                  }
                : null,
            }
          : undefined,
      }
    : null;

  return originReturnData;
};
